"use strict";
// Company-name normalisation shared across features that compare a free-text
// company name to a known Company record: the invoicing issuer-mismatch check
// and the operations counterparty→company auto-link. Legal-entity suffixes
// (Ltd / GmbH / SA / …), punctuation, and casing are normalised away so a
// trivial textual difference doesn't count as a different company.
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCompanyName = normalizeCompanyName;
const COMMON_COMPANY_SUFFIXES = [
    'limited',
    'ltd',
    'llc',
    'inc',
    'incorporated',
    'corp',
    'corporation',
    'co',
    'company',
    'gmbh',
    'ag',
    'sa',
    'srl',
    'spa',
    'bv',
    'nv',
    'kg',
    'oy',
    'ab',
    'as',
    'pty',
    'plc',
    'sl',
    'sarl',
    'sapi',
    'sas',
    'sasu',
    'eurl',
    'kft',
    'ooo',
    'pte',
    'pvt',
    'lp',
    'llp',
];
function normalizeCompanyName(raw) {
    if (raw === null || raw === undefined)
        return '';
    let s = raw.toLowerCase();
    // Strip dots and apostrophes without inserting whitespace so "A.C.M.E."
    // normalises to "acme" instead of breaking into one-letter tokens.
    s = s.replace(/['`’.]/g, '');
    // Remaining non-alphanumerics become a single space — keeps token
    // boundaries on commas, slashes, hyphens, etc.
    s = s.replace(/[^a-z0-9\s]+/g, ' ');
    s = s.replace(/\s+/g, ' ').trim();
    if (s === '')
        return '';
    const tokens = s.split(' ').filter((tok) => !COMMON_COMPANY_SUFFIXES.includes(tok));
    return tokens.join(' ').trim();
}
//# sourceMappingURL=company.js.map